<template>
  <div>
    <div
      v-for="item in items"
      class="text-question">
      <div class="question-title"
           :class="item.colorClass">
        <span>{{ item.title }}</span>
      </div>
      <div class="text" v-html="isTypeFile ? linkify(item.text) : item.text"></div>
    </div>
  </div>
</template>
<script>
  import { linkify } from '@/_helpers/utils';

  export default {
    name: 'text-question',
    props: {
      question: {
        type: Object,
        default: {}
      }
    },
    computed: {
      correctAnswer () {
        return this.question.isCorrect === 'correct'
      },
      notSelected () {
        return this.question.isCorrect === 'not-selected'
      },
      isTypeFile() {
        return this.question.type === 'file';
      },
      items () {
        let items = [];
        let chosenAnswer = this.question.answers.find(item => item.is_chosen);
        let firstAnswer = {};
        if (this.notSelected) {
          firstAnswer.title = this.$tr('responses.tabs.test.candidateAnswer');
          firstAnswer.text = chosenAnswer ? chosenAnswer.body : '';
        } else if (this.correctAnswer) {
          firstAnswer.title = this.$tr('responses.tabs.test.correct')
          firstAnswer.colorClass = 'green'
          firstAnswer.text = chosenAnswer ? chosenAnswer.body : '';
        } else {
          firstAnswer.title = this.$tr('responses.tabs.test.incorrect')
          firstAnswer.colorClass = 'red'
          firstAnswer.text = chosenAnswer ? chosenAnswer.body : '';
        }
        // else {
        //   console.log('items if 3')
        //   firstAnswer.title = this.$tr('responses.tabs.test.candidateAnswer')
        //   firstAnswer.text = chosenAnswer ? chosenAnswer.body : '';
        // }
        items.push(firstAnswer);
        if (!this.question.valid_answer || this.notSelected || this.correctAnswer) return items

        items.push({
          title: this.$tr('responses.tabs.test.correctAnswer'),
          text: this.question.valid_answer,
          color: null
        })
        return items
      }
    },
    methods: {
      linkify(text) {
        return linkify(text);
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.text-question {
  margin: 28px 0;
  font-size: 16px;

  .question-title {
    margin-bottom: 8px;
    // font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    color: #233346;
  }
  .green {
    color: $green !important;
    background-color: transparent !important;
    border-color: transparent !important;
  }

  .red {
    color: #f65046 !important;
    background-color: transparent !important;
    border-color: transparent !important;
  }
  .text {
    color: #233346;
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: #233346;
    white-space: pre-wrap;
  }
}
</style>
